import { Clipboard } from "@angular/cdk/clipboard";
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { AccountIdentity, RoomId, RoomPid } from "@common/domain";
import { Store } from "@ngrx/store";
import { TelemetryActions } from "@youm-front/telemetry/data-access";
import { timer } from "rxjs";
import { tap } from "rxjs/operators";
import { UiPopoverService } from "../../services";

@Component({
  selector: "app-ui-popover",
  templateUrl: "./ui-popover.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiPopoverComponent implements OnInit {
  @ViewChild("popoverInviteContent", { static: true, read: TemplateRef })
  popoverInviteContent!: TemplateRef<unknown>;

  @ViewChild("popoverContactSupportContent", {
    static: true,
    read: TemplateRef
  })
  popoverContactSupportContent!: TemplateRef<unknown>;

  constructor(
    private readonly store: Store,
    private readonly clipboard: Clipboard,
    private readonly uiPopoverService: UiPopoverService
  ) {}

  ngOnInit(): void {
    this.uiPopoverService.popoverInviteContent = this.popoverInviteContent;
    this.uiPopoverService.popoverContactSupportContent =
      this.popoverContactSupportContent;
  }

  onCopy(event: Event, text: string) {
    const target = event.target as HTMLElement;

    const copied = this.clipboard.copy(text);
    if (!copied) {
      return;
    }

    const originalInnerText = target.innerText;

    target.innerText = "Copied!";

    timer(5_000)
      .pipe(tap(() => (target.innerText = originalInnerText)))
      .subscribe();
  }

  onReportProblem(
    roomId: RoomId,
    roomPid: RoomPid,
    accountIdentity: AccountIdentity
  ) {
    this.store.dispatch(
      TelemetryActions.create({ roomId, roomPid, accountIdentity })
    );
  }
}
